import { makeAutoObservable, runInAction } from "mobx";

import apiInstance from "../services/api";

class VacancyStore {
  constructor(initialData) {
    makeAutoObservable(this);

    if (initialData) {
      this.selectedVacancy = initialData?.selectedVacancy || {};
    }
  }

  selectedVacancy = {};

  isVacancyLoading = false;

  setSelectedVacancy = (vacancy) => {
    this.selectedVacancy = vacancy;
  };

  setIsVacancyLoading = (state) => {
    this.isVacancyLoading = state;
  };

  fetchSingleVacancy = (vacancy) => {
    this.selectedVacancy = null;
    if (!vacancy.id) {
      return;
    }
    this.setIsVacancyLoading(true);

    apiInstance
      .getSingleVacancy(vacancy.id, vacancy.tenant)
      .then(({ data }) => {
        if (data) {
          this.setSelectedVacancy({
            ...vacancy,
            ...data?.positionProfile,
            companyName: data?.company?.name,
            endDate: data?.validTo,
            id: vacancy.id,
            status: data?.status,
          });
        }
      })
      .catch((err) =>
        // eslint-disable-next-line no-console
        console.error(`Error during fetch vacancy: ${vacancy.id} - ${err}`)
      )
      .finally(() => {
        runInAction(() => {
          this.setIsVacancyLoading(false);
        });
      });
  };
}

export default VacancyStore;
